<template>
  <div
    v-if="showLoadingState < 5"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyPaymentsSubscribedPlan"
    class="m-edition-billing-my-payments-subscribed-plan-info"
  >
    <div class="m-edition-billing-my-payments-subscribed-plan-info-left">
      <div class="m-card-record-info">
        <h4>
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.name') }}
          {{venta.venta.concepto_venta}}
        </h4>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.administrator') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.administradores }} de {{ academyResourcesLicencia.maximo_administradores }} en uso)</span>
            </span>
          <span class="info-text-right">
              {{ this.getPorcentaje(academyResourcesLicencia.administradores,academyResourcesLicencia.maximo_administradores) }}%
            </span>
        </p>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.teacher') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.profesores }} de {{ academyResourcesLicencia.maximo_profesores }} en uso)</span>
            </span>
          <span class="info-text-right">
              {{ this.getPorcentaje(academyResourcesLicencia.profesores,academyResourcesLicencia.maximo_profesores) }}%
            </span>
        </p>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.instructor') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.instructores }} de {{ academyResourcesLicencia.maximo_instructores }} en uso)</span>
            </span>
          <span class="info-text-right">
              {{ this.getPorcentaje(academyResourcesLicencia.instructores,academyResourcesLicencia.maximo_instructores) }}%
            </span>
        </p>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.student') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ academyResourcesLicencia.alumnos }} de {{ academyResourcesLicencia.maximo_alumnos }} en uso)</span>
            </span>
          <span class="info-text-right">
              {{ this.getPorcentaje(academyResourcesLicencia.alumnos,academyResourcesLicencia.maximo_alumnos) }}%
            </span>
        </p>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.projects') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.unlimited') }})</span>
            </span>
          <span class="info-text-right">
              <i class="far fa-infinity"></i>
            </span>
        </p>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.products') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.unlimited') }})</span>
            </span>
          <span class="info-text-right">
              <i class="far fa-infinity"></i>
            </span>
        </p>
        <p>
            <span class="info-text-left">
              Mapas de Aprendizaje
              <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.unlimited') }})</span>
            </span>
          <span class="info-text-right">
              <i class="far fa-infinity"></i>
            </span>
        </p>
        <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.mails') }}
              <span class="font-size-xsmall text-color-black-45"> (0 de {{ academyResourcesLicencia.maximo_emails }} en uso)</span>
            </span>
          <span class="info-text-right">
              {{ this.getPorcentaje(0,academyResourcesLicencia.maximo_emails) }}%
            </span>
        </p>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.salesData') }}
              <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.unlimited') }})</span>
            </span>
          <span class="info-text-right">
              <i class="far fa-infinity"></i>
            </span>
        </p>
        <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.commissions.line1') }}
            </span>
          <span class="info-text-right">
              {{ academyDataLicencia.comisiones }}%
            </span>
        </p>
        <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.commissions.line2') }}
            </span>
          <span class="info-icon-right info-icon-billing">
              <i class="fas fa-check"></i>
            </span>
        </p>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.academy') }}
            </span>
          <span
            v-if="academyDataLicencia.tipo_universidad"
            class="info-icon-right info-icon-billing"
          >
              <i class="fas fa-check"></i>
            </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
            </span>
        </p>
        <p>
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.integrations') }}
            </span>
          <span
            v-if="academyDataLicencia.integraciones"
            class="info-icon-right info-icon-billing"
          >
              <i class="fas fa-check"></i>
            </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
            </span>
        </p>
        <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.liveClasses') }}
            </span>
          <span
            v-if="academyDataLicencia.clases_vivo"
            class="info-icon-right info-icon-billing"
          >
              <i class="fas fa-check"></i>
            </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
            </span>
        </p>
        <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.affiliations') }}
            </span>
          <span
            v-if="academyDataLicencia.afiliaciones"
            class="info-icon-right info-icon-billing"
          >
              <i class="fas fa-check"></i>
            </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
            </span>
        </p>
        <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.evaluations') }}
            </span>
          <span
            v-if="academyDataLicencia.evaluaciones"
            class="info-icon-right info-icon-billing"
          >
              <i class="fas fa-check"></i>
            </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
            </span>
        </p>
        <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.studentControl') }}
            </span>
          <span
            v-if="academyDataLicencia.control_alumnos"
            class="info-icon-right info-icon-billing"
          >
              <i class="fas fa-check"></i>
            </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
            </span>
        </p>
        <p v-if="false">
            <span class="info-text-left">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.studentImport') }}
            </span>
          <span
            v-if="academyDataLicencia.importacion_alumnos"
            class="info-icon-right info-icon-billing"
          >
              <i class="fas fa-check"></i>
            </span>
          <span
            v-else
            class="info-text-right text-color-black-35"
          >
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoLeft.product.not') }}
            </span>
        </p>
      </div>
    </div>
    <div class="m-edition-billing-my-payments-subscribed-plan-info-right">
      <a
        v-if="ventaReemplazante"
        class="m-card-record-info m-card-record-link"
        @click="modalViewPendingChangePlan(Object.assign(ventaReemplazante, {'changePlan': true}))"
      >
        <p class="text-color-black-65">
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.paragraph') }}
        </p>
        <p class="recod-link-call-to-action recod-link-call-to-action-billing">
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.btn') }}
        </p>
      </a>

      <a
        v-else-if="suscripcionNotificada"
        class="m-card-record-info m-card-record-link"
        @click="modalViewPendingChangePlan({
            'suscripcion': suscripcionNotificada,
            'venta': venta.venta
          })"
      >
        <p
          v-if="suscripcionNotificada.id_plan === venta.venta.id_plan"
          class="m-card-record-info m-card-record-link"
        >
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingPaymentMethod.paragraph') }}
        </p>
        <p
          v-else
          class="m-card-record-info m-card-record-link"
        >
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.paragraph') }}
        </p>
        <p class="recod-link-call-to-action recod-link-call-to-action-billing">
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingPaymentMethod.btn') }}
        </p>
      </a>
      <a
        v-else
        class="m-card-record-info m-card-record-link"
        href="#"
        @click.prevent="goToChangePlan"
      >
        <p class="text-color-black-65">
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.changePlan.paragraph') }}
        </p>
        <p class="recod-link-call-to-action recod-link-call-to-action-billing">
          {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.changePlan.btn') }}
        </p>
      </a>
      <div class="m-card-record-info width-auto">
        <h4>{{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.title') }}</h4>
        <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-history"></i>
            </span>
          <span>
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.state.line1') }}
              <span :class="`font-weight-bold ${$filters.getSaleStateValue(venta.venta.venta_estado, 'class')}`">
                {{ $filters.getSaleStateValue(venta.venta.venta_estado, 'name') }}
              </span>
              <span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.state.line2') }}
                {{ $moment.parseZone(venta.venta.fecha_venta).format('D MMMM, YYYY') }}
              </span>
            </span>
        </p>
        <p v-if="venta.venta.fecha_cancelar_venta">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
          <span>
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.cancelDate') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone(venta.venta.fecha_cancelar_venta).format('D MMMM, YYYY') }}
              </span>
            </span>
        </p>
        <p>
              <span class="info-icon-left info-icon-billing">
                <i class="fas fa-receipt"></i>
              </span>
          <span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.name') }}
                {{venta.venta.concepto_venta}}
              </span>
        </p>
        <p v-if="venta.venta.id_plan">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-dollar-sign"></i>
            </span>
          <span v-if="venta.venta.venta_estado === 4 || venta.venta.venta_estado === 5">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.total') }} {{ venta.venta.divisa }}
              <span class="font-weight-bold">
                {{ venta.venta.total.toFixed(2) }}
              </span>
              <span class="text-color-black-35">
                {{ venta.venta.divisa_iso_code }}
              </span>
            </span>
          <span v-else-if="venta.venta.pago_cuotas">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.montoParcial') }} {{ venta.venta.divisa }}
              <span class="font-weight-bold">
                {{ venta.venta.total.toFixed(2) }}
              </span>
              <span>
                {{ venta.venta.divisa_iso_code }}
              </span>
              <span class="text-color-black-35">&sol;
                {{ venta.venta.divisa }}
                {{ (venta.venta.precio * venta.venta.pago_cuotas).toFixed(2) }}
                {{ venta.venta.divisa_iso_code }}
              </span>
            </span>
          <span v-else>
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.montoParcial') }} {{ venta.venta.divisa }}
              <span class="font-weight-bold">
                {{ venta.venta.total.toFixed(2) }}
              </span>
              <span class="text-color-black-35">
                {{ venta.venta.divisa_iso_code }}
              </span>
            </span>
        </p>
        <p v-else>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-dollar-sign"></i>
            </span>
          <span class="font-weight-bold">
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.free') }}
            </span>
        </p>
        <p v-if="venta.venta.trial_precio">
              <span class="info-icon-left info-icon-billing">
                <i class="far fa-clock"></i>
              </span>
          <span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.payTrial.line1') }}
                <span class="font-weight-bold">
                 {{ venta.venta.divisa }}
                 {{ venta.venta.trial_precio.toFixed(2) }}
                </span>
                <span class="text-color-black-35">
                  {{ venta.venta.divisa_iso_code }}
                </span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.payTrial.line2') }}
                {{ venta.venta.medio_pago }}
              </span>
        </p>
        <p v-if="venta.venta.trial_intervalo">
              <span class="info-icon-left info-icon-billing">
                <i class="far fa-clock"></i>
              </span>
          <span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.trial') }}
                <span class="font-weight-bold">
                  {{ venta.venta.trial_intervalo }}
                  {{ $filters.getFrequencyValue(venta.venta.trial_frecuencia, 'name') }}
                </span>
              </span>
        </p>
        <p v-if="venta.venta.id_plan && venta.venta.precio">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-money-bill"></i>
            </span>
          <span>
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.plan.line1') }}
              <span class="font-weight-bold">
                {{ $utils.getPaymentFrequency(venta.venta.pago_cuotas, venta.venta.pago_frecuencia, venta.venta.pago_intervalo) }}
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.plan.line2') }}
                {{ venta.venta.divisa }}
                {{ venta.venta.precio.toFixed(2) }}
              </span>
                <span class="text-color-black-35">
                  {{ venta.venta.divisa_iso_code }}
                </span>
            </span>
        </p>
        <p v-if="venta.venta.cupon_codigo">
              <span class="info-icon-left info-icon-billing">
                <i class="fas fa-percentage"></i>
              </span>
          <span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.cupon.line1') }}
                <span class="font-weight-bold">
                  {{ venta.venta.cupon_codigo }}
                </span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.cupon.line2') }}
                <span class="font-weight-bold">
                  {{ venta.venta.cupon_monto }}%
                </span>
              </span>
        </p>
        <p v-if="venta.venta.medio_pago">
              <span class="info-icon-left info-icon-billing">
                <i class="far fa-credit-card"></i>
              </span>
          <span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.payMethod') }}
                <span class="font-weight-bold">
                  {{ venta.venta.medio_pago }}
                </span>
              </span>
        </p>
        <p v-if="venta.venta.id_externo">
              <span class="info-icon-left info-icon-billing">
                <i class="fas fa-key"></i>
              </span>
          <span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.idExtern') }}
                {{ venta.venta.medio_pago }}
                <i class="text-color-black-65 font-weight-bold">
                  {{ venta.venta.id_externo }}
                </i>
              </span>
        </p>
        <div v-if="venta.venta.fecha_proximo_pago">
          <p v-if="venta.venta.fecha_inicio_suscripcion && $moment.parseZone().isBefore($moment.parseZone(venta.venta.fecha_inicio_suscripcion))">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.payNext') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone(venta.venta.fecha_inicio_suscripcion).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p v-else>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.payNext') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone(venta.venta.fecha_proximo_pago).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import abilities from '@/plugins/permissions/abilities'
import permissions from '@/plugins/permissions'

export default {
  name: 'MoleculeEditionBillingMyPaymentsSubscribedPlan',

  data () {
    return {
      academyDataLicencia: {},

      buttonPrimary: {
        action: 'CAMBIAR PLAN',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      showLoadingState: 0,
      suscripcionNotificada: null,

      venta: {},

      ventaReemplazante: null
    }
  },

  computed: {
    academyResourcesLicencia () {
      return this.$store.getters.getAcademyResources
    },

    /*
     | La venta trae en `satelites` las licencias de Droops que se compraron con ella. Si hay
     | alguna, el plan combina Vidroop con Droops y es personalizado: el cambio de plan no se
     | ofrece desde aca, se manda a soporte (ver el modal ChangePlanModalCustomized).
     */
    planPersonalizado () {
      return Array.isArray(this.venta.satelites) && this.venta.satelites.length > 0
    },

    trial () {
      return this.venta.venta.trial_intervalo &&
        this.venta.suscripcion &&
        this.venta.suscripcion.fecha_inicio &&
        this.$moment.parseZone().isBefore(this.$moment.parseZone(this.venta.suscripcion.fecha_inicio))
    }
  },

  created () {
    this.academyDataLicencia = this.$store.getters.getAcademyData.licencia
    this.readVenta()
    this.readChangePlan()
    this.readSubscriptionNotificada()
  },

  methods: {
    getPorcentaje (valor, maximo) {
      return parseInt((valor * 100) / maximo)
    },

    goToChangePlan () {
      if (this.planPersonalizado) {
        this.$modal.showModal('MoleculeEditionBillingMyPaymentsChangePlanModalCustomized')
        return
      }
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${this.$t('mEditionMenu.billing.myPayments.children.changePlan.subedition')}`)
    },

    modalViewPendingChangePlan (params) {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsModalPendingChangePlan', params)
    },

    readAcademias () {
      this.$services.read('academia', 'readAcademias', {}, [], this.$auth.filter)
        .then(response => {
          let currentAcademy = this.$store.getters.getAcademyData
          currentAcademy.licencia = response.data.find(a => a.id === this.$store.getters.getAcademyData.id).licencia
          if (currentAcademy.licencia.activa) {
            if (currentAcademy.current_ability === 'desactivado') {
              currentAcademy.current_ability = 'administrador'
              permissions.update([...abilities['administrador']])
            }
          } else {
            if (this.$route.params.subedition === this.$t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition')) {
              setTimeout(function () { this.readVenta() }.bind(this), 10000)
            }
          }
          localStorage.setItem('current_academy', JSON.stringify(currentAcademy))
          this.$store.commit('setAcademyData', currentAcademy)
          this.readAcademiaRecursosUsados()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readAcademiaRecursosUsados () {
      this.$services.read('academia', 'readAcademiaRecursosUsados', {}, [this.$store.getters.getAcademyData.id])
        .then(response => {
          localStorage.setItem('current_resources', JSON.stringify(response.data))
          this.$store.commit('setAcademyResources', response.data)
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readChangePlan () {
      this.$services.read('ventas', 'readChangePlan', {}, [this.academyDataLicencia.venta])
        .then(response => {
          if (response.status === 204) {
            this.ventaReemplazante = null
          } else {
            this.ventaReemplazante = response.data
            if (this.$route.params.subedition === this.$t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition')) {
              setTimeout(function () { this.readChangePlan() }.bind(this), 10000)
            }
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readSubscriptionNotificada () {
      this.$services.read('ventas', 'readSubscriptionNotificada', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          if (response.status === 204) {
            this.suscripcionNotificada = null
          } else {
            this.suscripcionNotificada = response.data
            if (this.$route.params.subedition === this.$t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition')) {
              setTimeout(function () { this.readSubscriptionNotificada() }.bind(this), 10000)
            }
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readVenta () {
      this.$services.read('ventas', 'readVenta', {}, [this.academyDataLicencia.venta])
        .then(response => {
          console.log(response.data)
          this.venta = response.data
          this.readAcademias()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
